var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmojiWindow),expression:"showEmojiWindow"}],attrs:{"title":"Pick your emoji","emoji":"point_up","native":true},on:{"select":_vm.addEmoji}})
}
var staticRenderFns = []

export { render, staticRenderFns }